<template>
  <div>
    <K-Loading :Loading="Loading" v-if="!datas"></K-Loading>
    <div class="box" v-else>
      <section v-if="list.length">
        <div class="result-img"><img :src="`/static/images/Normal15/${list.length>1?'error':'success'}.jpg`" /></div>
        <div class="result">
          <div class="title">您的查询结果如下：</div>
          <div class="text" v-if="list.length>1">该验证码已被多次查询，谨防假冒！</div>
          <div class="text" v-else>防伪码有效！感谢您选择正品ITO公司产品</div>
          <div class="record">
            <p v-for="(item, index) in list" :key="index">第{{ index+1 }}次扫描时间为：{{ item.created_at }}</p>
          </div>
        </div>
      </section>
      <div class="about"><img src="/static/images/Normal15/about.png" /></div>
    </div>
  </div>
</template>

<script>
let self;
import axios from 'axios'
import Loading from '@/components/Loading.vue'
import mixin from '../mixins/mixin.js'
export default {
  name: 'Normal16',
  components: {
    'K-Loading': Loading,
  },
  mixins: [mixin],
  data() {
    return {
      page: 1,
      list: [],
      datas: null
    }
  },
  watch: {
    datas (nval){
      this.GetRecord();
    }
  },
  created() {
    document.querySelector('body').setAttribute('style', 'background-color:#FFFFFF');
    const customWidth = 750; //设计图宽度
    const winWidth = document.body.offsetWidth;
    const initSize = winWidth / customWidth;
    const html = document.getElementsByTagName('html')[0];
    html.style.fontSize = initSize + 'px';
    this.GetDatas();  //获取码标信息
  },
  methods: {
    GetRecord () {
      axios.get(this.GetServerUrl(1)+"queryList/" + this.code+ "/" + this.page)
      .then((response)=>{
        let datas = response.data.meta.data;
        if(datas.length){
          this.list = datas.slice(0,5);
        }
      }).catch((error)=>{
        console.log(error)
      })
    }
  }
}
</script>
<style scoped>
img{
	display: block;
}
.result{
	padding: 20rem;
}
.title,.text{
	color: #000;
	font-weight: bolder;
	font-size: 27rem;
}
.text{
	padding: 20rem;
}
.record{
	color: #ccc;
	font-size: 25rem;
	padding: 0 20rem;
}
.record p{
	margin-bottom: 5rem;
}
.result-img img, .about img{
	display: block;
	width: 100%;
}
.about{
	margin-top: 5vh;
}
</style>



// WEBPACK FOOTER //
// src/view/Normal16.vue